
const classes = [
  'neighbor--white',
  'neighbor--light',
  'neighbor--dark',
  'neighbor--black',
];

function moveTags(container) {
  container.querySelectorAll('shopify-section').forEach(element => {
    element.classList.remove(classes);
  });
  container.querySelectorAll('.section:not(.bg--accent)').forEach(element => {
    element.parentElement.classList.add('neighbor--white');
  });
  container.querySelectorAll('.section--light.bg--accent').forEach(element => {
    element.parentElement.classList.add('neighbor--light');
  });
  container.querySelectorAll('.section--dark:not(.bg--accent)').forEach(element => {
    element.parentElement.classList.add('neighbor--dark');
  });
  container.querySelectorAll('.section--dark.bg--accent').forEach(element => {
    element.parentElement.classList.add('neighbor--black');
  });
}

export default moveTags;
